import React, { FC, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import GuestLayout from '../../components/layouts/guest_layout'
import FlatButton from '../../components/buttons/flat_button'

const ContactCompletePage: FC = () => {
  const navigate = useNavigate()

  // ページ読み込み時にトップにスクロール
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <GuestLayout>
      <div className="max-w-4xl w-full mx-auto">
        <div className="px-4 sm:px-8 py-8">
          <div className="text-center mb-8">
            <h1 className="font-bold text-2xl mb-4">
              お問い合わせ、ありがとうございました。
            </h1>
          </div>

          <div className="bg-main-white rounded-xl py-12 px-6">
            <div className="max-w-2xl mx-auto">
              <div className="text-left mb-8">
                <div className="leading-relaxed">
                  <p>
                    お問い合わせありがとうございます。
                    <br />
                    このたびは、SDGs 共創 Lodge
                    へお問い合わせ頂き誠にありがとうございます。
                    <br />
                    お送り頂きました内容を確認の上、3営業日以内に折り返しご連絡させて頂きます。
                    <br />
                    また、ご記入頂いたメールアドレスへ、自動返信の確認メールをお送りしております。
                    <br />
                    <br />
                    しばらく経ってもメールが届かない場合は、入力頂いたメールアドレスが間違っているか、迷惑メールフォルダに振り分けられている可能性がございます。
                    <br />
                    また、ドメイン指定をされている場合は、「cs@the-lodges.jp」からのメールが受信できるようあらかじめ設定をお願いいたします。
                    <br />
                    以上の内容をご確認の上、お手数ですがもう一度フォームよりお問い合わせ頂きますようお願い申し上げます。
                  </p>
                </div>
              </div>

              <div className="flex justify-center">
                <FlatButton
                  type="button"
                  onClick={() => navigate('/')}
                  outline
                  className="px-12 py-3"
                >
                  TOPページへ戻る
                </FlatButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </GuestLayout>
  )
}

export default ContactCompletePage
